import React, { Component } from "react";
import { Intervention } from "../../../../../store/onboarding/cases/types";
import { Modal, Spinner } from "react-bootstrap";

type OwnProps = {
  selectedIntervention: Intervention | undefined;
  handleUseAsIs: () => void;
  handleInterventionModify: () => void;
  handleClose: () => void;
  loading: { addInterventionsToGroup: boolean };
};

type Props = OwnProps;

class ModifyInterventionPopup extends Component<Props> {
  private popupRef?: HTMLDivElement | null;

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, false);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, false);
  }

  handleClickOutside = (event: any) => {
    if (event.target === this.popupRef) {
      this.props.handleClose();
    }
  };

  render() {
    return (
      <div
        data-cy="ask-to-modify-alert"
        className="smallAlertModal"
        ref={(ref) => (this.popupRef = ref)}
      >
    <Modal
      show={true}
      onHide={() => this.props.handleClose()}
      className="confirmDialogModal"
      animation={false}
      backdropClassName="customDarkModalBackdrop inner"
      centered
    >
      <Modal.Header closeButton className="purpleModalHeader font-weight-bold">
        <Modal.Title>Select an Option</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"pb-2 text-center"}>
            Would you like to use <strong>{this.props.selectedIntervention!.name}</strong> as is, or modify the steps?
          </div>
          <hr/>
          <div className="btnActions">
            <button
              className="whiteBtnSm"
              onClick={this.props.handleInterventionModify}
            >
              Modify steps
            </button>
            <button
              data-cy="use-as-is-btn"
              className="blueBtnSm"
              onClick={this.props.handleUseAsIs}
            >
              Use as is{" "}
              {this.props.loading.addInterventionsToGroup && (
                <Spinner animation="border" size="sm" />
              )}
            </button>
          </div>
      </Modal.Body>
    </Modal>
      </div>
    );
  }
}

export default ModifyInterventionPopup;
